import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.397 2.03a.78.78 0 0 1 .553-.23h4.472a.782.782 0 0 1 .778.778v4.473a.782.782 0 0 1-1.564 0V4.469L8.164 8.944a.785.785 0 1 1-1.109-1.108l4.477-4.472H8.95a.782.782 0 0 1-.553-1.335",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1.8 4.816c0-.74.6-1.34 1.34-1.34h4.022v1.34H3.141v8.044h8.043V8.838a.67.67 0 0 1 1.34 0v4.022c0 .74-.6 1.34-1.34 1.34H3.14c-.74 0-1.341-.6-1.341-1.34z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })